// extracted by mini-css-extract-plugin
module.exports = {"maxWidthSmallScreenDesktop":"960px","eddMessageWrapper":"eddMessageContainer_eddMessageWrapper__lWUVj","zipcodeBtnClass":"eddMessageContainer_zipcodeBtnClass__s6eh5"};